import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AttributeFormLayer from "../components/AttributeFormLayer";

const AttributeFormPage = () => {
    return (
        <MasterLayout>
            <AttributeFormLayer />
        </MasterLayout>
    );
};

export default AttributeFormPage;
